import { motion } from "framer-motion";
import Navigation from "../components/Navigation";
import Hero from "../components/Hero";
import MarqueeBand from "../components/Marquee";
import SelectedWork from "../components/SelectedWork";
import About from "../components/About";
import Experience from "../components/Experience";
import Testimonials from "../components/Testimonials";
import Process from "../components/Process";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Playground from "../components/Playground";

const Home = () => {
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
      data-testid="home-page"
    >
      <Navigation />
      <Hero />
      <MarqueeBand />
      <SelectedWork />
      <About />
      <Process />
      <Experience />
      <Testimonials />
      <Playground />
      <FAQ />
      <Contact />
      <Footer />
    </motion.main>
  );
};

export default Home;
